import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State as LeaseDetailsState } from '../reducers/lease-details';
export const selectLeaseDetailsState = createFeatureSelector<LeaseDetailsState>('leaseDetails');

export const selectLeaseDetails = createSelector(
  [selectLeaseDetailsState], (leaseDetailsState: LeaseDetailsState) => {
    return leaseDetailsState.leaseDetails;
  }
);
